import L from 'leaflet';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

let isLeafletInitialized = false;

export const initLeafletIcons = () => {
    if (isLeafletInitialized) return;

    // Corrigir ícones do leaflet em webpack/vite (issue comum do react-leaflet)
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
    });

    isLeafletInitialized = true;
};
